import { getApiClient } from '../../api/client';
import type { components } from '../../api/schema';

export type ZipBlastCreateBody = components['schemas']['ZipBlastRequestCreate'];

export async function listZipBlasts(page = 1, limit = 50) {
  const client = getApiClient();
  const { data, error } = await client.GET('/zip-blasts', {
    params: { query: { page, limit } },
  });
  if (error) throw new Error(`Failed to fetch zip blasts: ${JSON.stringify(error)}`);
  return data;
}

export async function getZipBlast(uuid: string) {
  const client = getApiClient();
  const { data, error } = await client.GET('/zip-blasts/{uuid}', {
    params: { path: { uuid } },
  });
  if (error) throw new Error(`Failed to fetch zip blast: ${JSON.stringify(error)}`);
  return data;
}

export async function createZipBlast(body: ZipBlastCreateBody) {
  const client = getApiClient();
  const { data, error } = await client.POST('/zip-blasts', { body });
  if (error) throw new Error(`Failed to create zip blast: ${JSON.stringify(error)}`);
  return data;
}

export async function cancelZipBlast(uuid: string) {
  const client = getApiClient();
  const { data, error } = await client.POST('/zip-blasts/{uuid}/cancel', {
    params: { path: { uuid } },
  });
  if (error) throw new Error(`Failed to cancel zip blast: ${JSON.stringify(error)}`);
  return data;
}

export async function retryZipBlast(uuid: string) {
  const client = getApiClient();
  const { data, error } = await client.POST('/zip-blasts/{uuid}/retry', {
    params: { path: { uuid } },
  });
  if (error) throw new Error(`Failed to retry zip blast: ${JSON.stringify(error)}`);
  return data;
}

export async function getZipBlastMetrics(campaign_uuid?: string | null) {
  const client = getApiClient();
  const { data, error } = await client.GET('/zip-blasts/metrics', {
    params: { query: { campaign_uuid: campaign_uuid ?? undefined } },
  });
  if (error) throw new Error(`Failed to fetch zip blast metrics: ${JSON.stringify(error)}`);
  return data;
}
